import { render, staticRenderFns } from "./multiText.vue?vue&type=template&id=601c24a4&scoped=true&"
import script from "./multiText.vue?vue&type=script&lang=js&"
export * from "./multiText.vue?vue&type=script&lang=js&"
import style0 from "./multiText.vue?vue&type=style&index=0&id=601c24a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c24a4",
  null
  
)

export default component.exports